/* eslint-disable @calm/react-intl/missing-formatted-message */
import React from 'react';
import styled from 'styled-components';
import { ProductiveHeading01 } from 'ozone/atoms';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-05);
  padding: var(--spacing-05);
  background-color: var(--white-100);
  box-shadow: 0px 3.2px 7.2px rgba(0, 0, 0, 0.13),
    0px 0.6px 1.8px rgba(0, 0, 0, 0.11);
  width: 214px;
  max-width: 220px;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-01);
`;

const Header = styled.div`
  ${ProductiveHeading01};
  font-weight: var(--font-weight-bold) !important;
`;

const TextWrapper = styled.div``;

const Info = styled.span`
  max-width: 175px;
  font-family: var(--font-family) !important;
  font-size: var(--font-size-base) !important;
  line-height: var(--line-height-body-short-02) !important;
  white-space: initial;
  overflow-wrap: break-word;
  text-overflow: initial;
`;

const GreenText = styled(Info)`
  color: var(--green-40);
`;

const RedText = styled(Info)`
  color: var(--red-50);
`;

const GreyText = styled(Info)`
  color: var(--gray-50);
`;

const BoldText = styled(Info)`
  font-weight: var(--font-weight-bold);
`;

const BoldGreenText = styled(GreenText)`
  font-weight: var(--font-weight-bold);
`;

const BoldRedText = styled(RedText)`
  font-weight: var(--font-weight-bold);
`;

const formatText = (number, text) =>
  Number(number) > 1 ? ` ${number} ${text}s` : ` ${number} ${text}`;

export const IntervalsAsAbsoluteValueTooltip = ({
  intervalName,
  value,
  noOfProjects,
  date,
}) => {
  const projects = formatText(noOfProjects, 'project');

  return (
    <Wrapper>
      <Header>
        <Info>{`Avg. of ${intervalName} : `}</Info>
        <BoldGreenText>{formatText(value, 'day')}</BoldGreenText>
      </Header>

      <Section>
        <GreyText>Avg. planned duration was 25 days</GreyText>
      </Section>

      <Section>
        <TextWrapper>
          <Info>Calculated from</Info>
          <BoldText>{projects}</BoldText>
        </TextWrapper>
        <GreyText>{date}</GreyText>
      </Section>
    </Wrapper>
  );
};

export const IntervalsAsDeviationTooltip = ({
  intervalName,
  value,
  noOfProjects,
  date,
}) => {
  const projects = formatText(noOfProjects, 'project');

  return (
    <Wrapper>
      <Section>
        <Section>
          <BoldText>{`Avg. ${intervalName} : `}</BoldText>
          <TextWrapper>
            {value < 0 ? (
              <>
                <GreenText>Earlier than planned duration by</GreenText>
                <BoldGreenText>
                  {formatText(Number(value) * -1, 'day')}
                </BoldGreenText>
              </>
            ) : (
              <>
                <RedText>Delayed than planned duration by</RedText>
                <BoldRedText>{formatText(value, 'day')}</BoldRedText>
              </>
            )}
          </TextWrapper>
        </Section>
      </Section>

      <Section>
        <GreyText>Avg. planned duration was 25 days</GreyText>
      </Section>

      <Section>
        <TextWrapper>
          <Info>Calculated from</Info>
          <BoldText>{projects}</BoldText>
        </TextWrapper>
        <GreyText>{date}</GreyText>
      </Section>
    </Wrapper>
  );
};

export const KeyEventsAsDeviationTooltip = ({
  keyEventName,
  value,
  noOfProjects,
  date,
}) => {
  const projects = formatText(noOfProjects, 'project');

  return (
    <Wrapper>
      <Section>
        <BoldText>{keyEventName}</BoldText>
      </Section>

      <Section>
        <TextWrapper>
          {value < 0 ? (
            <>
              <GreenText>Earlier than planned by</GreenText>
              <BoldGreenText>
                {`${formatText(Number(value) * -1, 'day')} on avg`}
              </BoldGreenText>
            </>
          ) : value === 0 ? (
            <GreenText>On Time</GreenText>
          ) : (
            <>
              <RedText>Delayed than planned by</RedText>
              <BoldRedText>{`${formatText(value, 'day')} on avg`}</BoldRedText>
            </>
          )}
        </TextWrapper>
      </Section>

      <Section>
        <TextWrapper>
          <Info>Calculated from</Info>
          <BoldText>{projects}</BoldText>
        </TextWrapper>
        <GreyText>{date}</GreyText>
      </Section>
    </Wrapper>
  );
};
